// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x_ab","right":"styles_right__1vNBk"};